export const isSecure = (): boolean => window.location.protocol === 'https:';
